import styled from 'styled-components';

import { Button } from '@savgroup-front-common/core';

export const $BulkActionContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 30px;
  right: 30px;
  padding: 5px 16px;
  background-color: ${({ theme }) => theme.newUI?.defaultColors?.menu ?? theme.colors?.primary ?? '#5369eb'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.bigRadius ?? theme.borders?.radius ?? '8px'};
  display: flex;
  align-items: center;
  box-shadow: ${({ theme }) =>
    (theme.newUI?.shadows as { level1?: string; level2?: string } | undefined)?.level2 ??
    '0 4px 12px rgba(0,0,0,0.15)'};
`;

export const $BulkActionCounter = styled.div`
  color: ${({ theme }) => theme.colors?.white ?? '#fff'};
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const $BulkActionButton = styled(Button)`
  margin-left: auto;
  margin-right: 10px;
`;
